var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCurrentLocation = function SvgCurrentLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9E9E9E",
    d: "M13.8 12a1.8 1.8 0 1 1-3.6 0 1.8 1.8 0 0 1 3.6 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#9E9E9E",
    fillRule: "evenodd",
    d: "M11.25 3.03a9 9 0 0 0-8.22 8.22H3v1.5h.03a9 9 0 0 0 8.22 8.22V21h1.5v-.03a9 9 0 0 0 0-17.94V3h-1.5zm0 1.507V6.6h1.5V4.537a7.5 7.5 0 0 1 6.713 6.713H16.5v1.5h2.963a7.5 7.5 0 0 1-6.713 6.713V17.4h-1.5v2.063a7.5 7.5 0 0 1-6.713-6.713H6.6v-1.5H4.537a7.5 7.5 0 0 1 6.713-6.713",
    clipRule: "evenodd"
  })));
};
export default SvgCurrentLocation;